<script setup>
  let props = defineProps(['visible']);
  let emit = defineEmits(['close', 'click', 'contextmenu']);

  function ignoreEvent (e) {
    e.stopPropagation();
  }

  function closeProperties (e) {
    ignoreEvent(e);
    emit('close', e);
  }
</script>

<template>
  <div class="property-page" v-if="visible" @click="e => emit('click', e)" @contextmenu="e => emit('contextmenu', e)" @pointerdown="ignoreEvent" @mousedown="ignoreEvent">
    <div class="inputs">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.property-page {
  position: relative;
  pointer-events: all;
  overflow: auto;
  padding: 1em;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}

.title {
  text-align: center;
  font-size: 1.25em;
  padding: 0.25em 1em;
  margin: 0;
  flex: 0 0 auto;
}

.menu-divider {
  flex: 0 0 auto;
}

.close {
  position: absolute;
  font-size: 2.9em;
  top: 0;
  right: 0;
  padding: 0 0.15em;
  margin: 0;
  line-height: 1;
}

.close, .close:hover, .close:active {
  color: #800;
  text-decoration: none;
}

.inputs {
  flex: 1 1 auto;
  overflow: visible;
}
</style>
